import { useEffect, useState } from "react";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import KPISaleService from "../../../services/KPISaleService";
import withLoader from "../../../components/layouts/WithLoader";

const KpiSaleB2B = ({ finalYear }) => {
  // const finalYear = new Date().getFullYear();
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageDBC, setCurrentPageDBC] = useState(1);
  const [currentPageDBC1, setCurrentPageDBC1] = useState(1);
  const [currentPageDBC2, setCurrentPageDBC2] = useState(1);

  const [toByYear, setToByYear] = useState([]);
  const [toBDCByYear, setToBDCByYear] = useState([]);
  const [nbrFacturesPayed, setNbrFacturesPayed] = useState([]);

  const [nbrBDCMonthsInYear, setNbrBDCMonthsInYear] = useState([]);

  const [nbrDevisMonthsInYear, setNbrDevisMonthsInYear] = useState([]);

  const [nbrFacturesNotPayed, setNbrFacturesNotPayed] = useState([]);

  useEffect(() => {
    getKPISale();
  }, []);

  const getKPISale = (e) => {
    KPISaleService.getToByYear(getCurrentUserId(), finalYear)
      .then((response) => {
        setToByYear(response.data);
      })
      .catch((error) => {
        console.log("error: " + error);
      });

    KPISaleService.getBDCToByYear(getCurrentUserId(), finalYear)
      .then((response) => {
        setToBDCByYear(response.data);
      })
      .catch((error) => {
        console.log("error: " + error);
      });
    KPISaleService.numberFacturePayed(getCurrentUserId(), finalYear)
      .then((response) => {
        if (response.data[0].id === 1) {
          setNbrFacturesPayed(response.data[0]);
        } else if (response.data[0].id === 0) {
          setNbrFacturesNotPayed(response.data[0]);
        }

        if (response.data[1].id === 1) {
          setNbrFacturesPayed(response.data[1]);
        } else if (response.data[1].id === 0) {
          setNbrFacturesNotPayed(response.data[1]);
        }
      })
      .catch((error) => {
        console.log("error: " + error);
      });

    KPISaleService.numberBDCMonthsInYear(getCurrentUserId(), finalYear)
      .then((response) => {
        setNbrBDCMonthsInYear(response.data);
      })
      .catch((error) => {
        console.log("error: " + error);
      });

    KPISaleService.numberDevisMonthsInYear(getCurrentUserId(), finalYear)
      .then((response) => {
        setNbrDevisMonthsInYear(response.data);
      })
      .catch((error) => {
        console.log("error: " + error);
      });
  };

  const resultTable = (currentPage, setCurrentPage) => {
    const itemsPerPage = 5; // Set number of rows per page

    const handlePageChange = (page) => {
      // Ensure the page number stays within bounds
      if (page >= 1 && page <= totalPages) {
        setCurrentPage(page);
      }
    };

    // Calculate the paginated data
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedData = toByYear.slice(startIndex, startIndex + itemsPerPage);

    // Calculate total pages
    const totalPages = Math.ceil(toByYear.length / itemsPerPage);

    // function roundingDigitsto3(number) {
    //   if(number!==null){
    //     const truncatedAmount = parseFloat(number.toFixed(3));

    //     return truncatedAmount;
    //   }else{
    //     return 0;

    //   }
      
    // }

    function calculeCA(number1, number2) {
      const ca = number1 + number2;
      // const truncatedAmount = parseFloat(ca.toFixed(3));

      return ca;
    }
    if (toByYear&&toByYear.length > 0) {
      return (
        <section className="content">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title">
                      Les statistiques vente B2B : {finalYear}
                    </h3>
                    <br />
                    <p>
                      Chiffre d'affaire total:{" "}
                      {calculeCA(
                        nbrFacturesPayed?.totalAmountSellingPrice,
                        nbrFacturesNotPayed?.totalAmountSellingPrice
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-md-6 col-sm-6 col-12">
                <div className="info-box bg-success">
                  <span className="info-box-icon">
                    <i className="fa-solid fa-plus"></i>
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">
                      Nombre des factures payées pour {finalYear}
                    </span>
                    <span className="info-box-number">
                      {nbrFacturesPayed?.count} vaut:{" "}
                      {nbrFacturesPayed?.totalAmountSellingPrice}
                      {/* {roundingDigitsto3(
                        nbrFacturesPayed?.totalAmountSellingPrice
                      )} */}
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-sm-6 col-12">
                <div className="info-box bg-danger">
                  <span className="info-box-icon">
                    <i className="fa-solid fa-minus"></i>
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">
                      Nombre des factures non payées pour {finalYear}
                    </span>
                    <span className="info-box-number">
                      {nbrFacturesNotPayed?.count} vaut:{" "}
                      {nbrFacturesNotPayed?.totalAmountSellingPrice}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title">
                      Résultat de l'année : {finalYear}
                    </h3>
                  </div>
                  <div className="card-body p-0">
                    <table className="table table-condensed">
                      <thead>
                        <tr>
                          <th style={{ width: 10 }}>Mois</th>
                          <th style={{ width: 20 }}>Total Prix Initial</th>
                          <th style={{ width: 10 }}>Promotion %</th>
                          <th style={{ width: 20 }}>Total Prix HTC</th>
                          <th style={{ width: 20 }}>Total TVA</th>
                          <th style={{ width: 20 }}>Total Prix TTC</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedData.map((element) => (
                          <tr key={element?.id?.month}>
                            <td>
                              {element?.id?.month}-{finalYear}
                            </td>
                            <td>{element?.totalAmountInitialPrice}</td>
                            <td>
                              <span className="badge bg-warning">
                                {extractDigitsAfterDecimal(
                                  element?.promotionPercentage
                                )}
                                %
                              </span>
                            </td>
                            <td>{element?.totalAmountSellingPrice}</td>
                            <td>{element?.totalAmountTVA}</td>
                            <td>{element?.totalAmountPriceTT}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  {/* Pagination Controls */}
                  <div className="react-bootstrap-table-pagination-list pr-5">
                    <ul className="pagination react-bootstrap-table-page-btns-ul">
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="btn btn-dark"
                          style={{
                            backgroundColor: "white",
                            color: "black",
                          }}
                          onClick={() => handlePageChange(currentPage - 1)}
                        >
                          &lt;
                        </button>
                      </li>
                      {Array.from({ length: totalPages }, (_, index) => (
                        <li
                          key={index + 1}
                          className={`page-item ${
                            currentPage === index + 1 ? "active" : ""
                          }`}
                        >
                          <button
                            className="btn btn-dark"
                            style={{
                              backgroundColor:
                                currentPage === index + 1 ? "black" : "white",
                              color:
                                currentPage === index + 1 ? "white" : "black",
                            }}
                            onClick={() => handlePageChange(index + 1)}
                          >
                            {index + 1}
                          </button>
                        </li>
                      ))}
                      <li
                        className={`page-item ${
                          currentPage === totalPages ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="btn btn-dark"
                          style={{
                            backgroundColor: "white",
                            color: "black",
                          }}
                          onClick={() => handlePageChange(currentPage + 1)}
                        >
                          &gt;
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      );
    }
  };
  function extractDigitsAfterDecimal(number) {
    return Math.round(number * 1000) / 1000;
  }
  const resultTableBDC = (currentPage, setCurrentPage) => {
    const itemsPerPage = 5; // Number of rows per page

    const handlePageChange = (page) => {
      // Ensure the page number stays within bounds
      if (page >= 1 && page <= totalPages) {
        setCurrentPage(page);
      }
    };
    // Calculate paginated data
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedData = toBDCByYear.slice(
      startIndex,
      startIndex + itemsPerPage
    );

    // Calculate total pages
    const totalPages = Math.ceil(toBDCByYear.length / itemsPerPage);

    if (toBDCByYear&&toBDCByYear.length > 0) {
      return (
        <section className="content ">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title">
                      Les Bon de commandes de l'année : {finalYear}
                    </h3>
                  </div>
                  {/* Card Body with Paginated Table */}
                  <div className="card-body p-0">
                    <table className="table table-condensed">
                      <thead>
                        <tr>
                          <th style={{ width: 10 }}>Mois</th>
                          <th style={{ width: 20 }}>Total Prix Initial</th>
                          <th style={{ width: 10 }}>Promotion %</th>
                          <th style={{ width: 20 }}>Total Prix HTC</th>
                          <th style={{ width: 20 }}>Total TVA</th>
                          <th style={{ width: 20 }}>Total Prix TTC</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedData.map((element, index) => (
                          <tr key={index}>
                            <td>
                              {element?.id?.month}-{finalYear}
                            </td>
                            <td>{element?.totalAmountInitialPrice}</td>
                            <td>
                              <span className="badge bg-warning">
                                {extractDigitsAfterDecimal(
                                  element?.promotionPercentage
                                )}
                                %
                              </span>
                            </td>
                            <td>{element?.totalAmountSellingPrice}</td>
                            <td>{element?.totalAmountTVA}</td>
                            <td>{element?.totalAmountPriceTT}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  {/* Pagination Controls */}
                  <div className="react-bootstrap-table-pagination-list pr-5">
                    <ul className="pagination react-bootstrap-table-page-btns-ul">
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="btn btn-dark"
                          style={{
                            backgroundColor: "white",
                            color: "black",
                          }}
                          onClick={() => handlePageChange(currentPage - 1)}
                        >
                          &lt;
                        </button>
                      </li>
                      {Array.from({ length: totalPages }, (_, index) => (
                        <li
                          key={index + 1}
                          className={`page-item ${
                            currentPage === index + 1 ? "active" : ""
                          }`}
                        >
                          <button
                            className="btn btn-dark"
                            style={{
                              backgroundColor:
                                currentPage === index + 1 ? "black" : "white",
                              color:
                                currentPage === index + 1 ? "white" : "black",
                            }}
                            onClick={() => handlePageChange(index + 1)}
                          >
                            {index + 1}
                          </button>
                        </li>
                      ))}
                      <li
                        className={`page-item ${
                          currentPage === totalPages ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="btn btn-dark"
                          style={{
                            backgroundColor: "white",
                            color: "black",
                          }}
                          onClick={() => handlePageChange(currentPage + 1)}
                        >
                          &gt;
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      );
    }
  };

  const resultTableNBRDevisNbr = (currentPage, setCurrentPage) => {
    const itemsPerPage = 5; // Number of rows per page

    const handlePageChange = (page) => {
      // Ensure the page number stays within bounds
      if (page >= 1 && page <= totalPages) {
        setCurrentPage(page);
      }
    };

    // Calculate paginated data
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedData = nbrDevisMonthsInYear.slice(
      startIndex,
      startIndex + itemsPerPage
    );

    // Calculate total pages
    const totalPages = Math.ceil(nbrDevisMonthsInYear.length / itemsPerPage);

    if (nbrDevisMonthsInYear&&nbrDevisMonthsInYear.length > 0) {
      return (
        <div className="col-sm-6">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Les Devis de l'année : {finalYear}</h3>
            </div>
            <div className="card-body p-0">
              <table className="table table-condensed">
                <thead>
                  <tr>
                    <th style={{ width: 10 }}>Mois</th>
                    <th style={{ width: 20 }}>Non Validé</th>
                    <th style={{ width: 20 }}>Validé En Commande</th>
                    <th style={{ width: 20 }}>Validé en BDC</th>
                    <th style={{ width: 20 }}>Total </th>
                    <th style={{ width: 10 }}>Taux de validation %</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedData.map((element, index) => (
                    <tr key={index}>
                      <td>
                        {element?.month}-{finalYear}
                      </td>
                      <td>{element?.countEnAttente}</td>
                      <td>{element?.countEnCours}</td>
                      <td>{element?.countLivred}</td>
                      <td>{element?.countAll}</td>
                      <td>
                        <span className="badge bg-warning">
                          {extractDigitsAfterDecimal(element?.taux)}%
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {/* Pagination Controls */}
            <div className="react-bootstrap-table-pagination-list pr-5">
              <ul className="pagination react-bootstrap-table-page-btns-ul">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    className="btn btn-dark"
                    style={{
                      backgroundColor: "white",
                      color: "black",
                    }}
                    onClick={() => handlePageChange(currentPage - 1)}
                  >
                    &lt;
                  </button>
                </li>
                {Array.from({ length: totalPages }, (_, index) => (
                  <li
                    key={index + 1}
                    className={`page-item ${
                      currentPage === index + 1 ? "active" : ""
                    }`}
                  >
                    <button
                      className="btn btn-dark"
                      style={{
                        backgroundColor:
                          currentPage === index + 1 ? "black" : "white",
                        color: currentPage === index + 1 ? "white" : "black",
                      }}
                      onClick={() => handlePageChange(index + 1)}
                    >
                      {index + 1}
                    </button>
                  </li>
                ))}
                <li
                  className={`page-item ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="btn btn-dark"
                    style={{
                      backgroundColor: "white",
                      color: "black",
                    }}
                    onClick={() => handlePageChange(currentPage + 1)}
                  >
                    &gt;
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      );
    }
  };

  const resultTableNBRBDCNbr = (currentPage, setCurrentPage) => {
    const itemsPerPage = 5; // Number of rows per page

    const handlePageChange = (page) => {
      // Ensure the page number stays within bounds
      if (page >= 1 && page <= totalPages) {
        setCurrentPage(page);
      }
    };

    // Calculate paginated data
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedData = nbrBDCMonthsInYear.slice(
      startIndex,
      startIndex + itemsPerPage
    );

    // Calculate total pages
    const totalPages = Math.ceil(nbrBDCMonthsInYear.length / itemsPerPage);

    if (nbrBDCMonthsInYear&&nbrBDCMonthsInYear.length > 0) {
      return (
        <div className="col-sm-6">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Les BDC de l'année : {finalYear}</h3>
            </div>
            <div className="card-body p-0">
              <table className="table table-condensed">
                <thead>
                  <tr>
                    <th style={{ width: 10 }}>Mois</th>
                    <th style={{ width: 20 }}>En attente</th>
                    <th style={{ width: 20 }}>En cours</th>
                    <th style={{ width: 20 }}>Livrés</th>
                    <th style={{ width: 20 }}>Total </th>
                    <th style={{ width: 10 }}>Taux de Livraison %</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedData.map((element, index) => (
                    <tr key={index}>
                      <td>
                        {element?.month}-{finalYear}
                      </td>
                      <td>{element?.countEnAttente}</td>
                      <td>{element?.countEnCours}</td>
                      <td>{element?.countLivred}</td>
                      <td>{element?.countAll}</td>
                      <td>
                        <span className="badge bg-warning">
                          {extractDigitsAfterDecimal(element?.taux)}%
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {/* Pagination Controls */}
            <div className="react-bootstrap-table-pagination-list pr-5">
              <ul className="pagination react-bootstrap-table-page-btns-ul">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    className="btn btn-dark"
                    style={{
                      backgroundColor: "white",
                      color: "black",
                    }}
                    onClick={() => handlePageChange(currentPage - 1)}
                  >
                    &lt;
                  </button>
                </li>
                {Array.from({ length: totalPages }, (_, index) => (
                  <li
                    key={index + 1}
                    className={`page-item ${
                      currentPage === index + 1 ? "active" : ""
                    }`}
                  >
                    <button
                      className="btn btn-dark"
                      style={{
                        backgroundColor:
                          currentPage === index + 1 ? "black" : "white",
                        color: currentPage === index + 1 ? "white" : "black",
                      }}
                      onClick={() => handlePageChange(index + 1)}
                    >
                      {index + 1}
                    </button>
                  </li>
                ))}
                <li
                  className={`page-item ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="btn btn-dark"
                    style={{
                      backgroundColor: "white",
                      color: "black",
                    }}
                    onClick={() => handlePageChange(currentPage + 1)}
                  >
                    &gt;
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      );
    }
  };

  const resultTableDevisBDCNbr = (
    currentPageDBC1,
    setCurrentPageDBC1,
    currentPageDBC2,
    setCurrentPageDBC2
  ) => {
    return (
      <section className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            {resultTableNBRDevisNbr(currentPageDBC1, setCurrentPageDBC1)}
            {resultTableNBRBDCNbr(currentPageDBC2, setCurrentPageDBC2)}
          </div>
        </div>
      </section>
    );
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-sm-12">
          {resultTable(currentPage, setCurrentPage)}
        </div>
        <div className="col-sm-12">
          {resultTableBDC(currentPageDBC, setCurrentPageDBC)}
          {resultTableDevisBDCNbr(
            currentPageDBC1,
            setCurrentPageDBC1,
            currentPageDBC2,
            setCurrentPageDBC2
          )}
        </div>
      </div>
    </div>
  );
};
export default KpiSaleB2B;
